<template>
  <div>
    <div
      class="wraper"
      v-if="(!isLoading && !isProjectLoadingError) || isFirstLoaded"
    >
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <ProjectHeader></ProjectHeader>
        <div
          v-if="
            step !== 'about_' &&
              !['users', 'lizing'].includes(this.currentUser.ACTIVE_ROLE_CODE)
          "
          class="row myrow"
        >
          <div class="col-md-12 mycol stage-menu">
            <div class="stage-menu-item">
              <button
                type="button"
                title="Этап 1. Описание проекта"
                v-bind:class="{ active: step === 'about' }"
                v-on:click="SetStep('about')"
              >
                Карточка заявки
              </button>
            </div>

            <div class="stage-menu-item">
              <button
                type="button"
                title="Этап 1. Описание проекта"
                v-bind:class="{ active: step === 'description' }"
                v-on:click="SetStep('description')"
              >
                Этап 1. Описание проекта
              </button>
            </div>

            <div class="stage-menu-item" v-show="false">
              <button
                type="button"
                title="Этап 2. Список закупаемого"
                v-bind:class="{ active: step === '7' }"
                v-on:click="SetStep('7')"
              >
                Этап 2. Список закупаемого
              </button>
            </div>

            <div class="stage-menu-item" v-if="getProgramCode() !== 'lizing'">
              <button
                type="button"
                title="Этап 2. Бюджет, источники финансирования"
                class="stage-menu-item__butt"
                :class="{ active: step === 'budget' }"
                @click="SetStep('budget')"
              >
                <span class="df-ac" v-if="getProgramCode() !== 'lekarstva'">
                  <span>
                    Этап 2. Бюджет, источники финансирования
                  </span>
                  <a
                    v-if="project.UF_VID_BUDGET > 3"
                    @click="startSecondScenariy"
                    class="screenplay-start"
                  />
                </span>
                <span v-else>Этап 2. Бюджет, обеспечение</span>
              </button>
            </div>

            <div class="stage-menu-item" v-if="getProgramCode() === 'lizing'">
              <button
                type="button"
                title="Этап 2. Цели и показатели проекта"
                class="stage-menu-item__butt"
                :class="{ active: step === 'planned-indicators' }"
                @click="SetStep('planned-indicators')"
              >
                Этап 2. Цели и показатели проекта
              </button>
            </div>
            <div class="stage-menu-item">
              <template v-if="getProgramCode() === 'lizing'">
                <button
                  type="button"
                  title="Этап 3. Обеспечение"
                  class="stage-menu-item__butt"
                  v-bind:class="{ active: step === 'banking-security' }"
                  v-on:click="SetStep('banking-security')"
                >
                  <span>Этап 3. Обеспечение</span>
                  <a @click="startThirdScenariy" class="screenplay-start" />
                </button>
              </template>
              <template v-else>
                <button
                  type="button"
                  title="Этап 3. Цели и показатели проекта"
                  class="stage-menu-item__butt"
                  :class="{ active: step === 'planned-indicators' }"
                  @click="SetStep('planned-indicators')"
                >
                  Этап 3. Цели и показатели проекта
                </button>
              </template>
            </div>

            <div
              class="stage-menu-item"
              v-if="
                getProgramCode() !== 'lekarstva' &&
                  getProgramCode() !== 'lizing' &&
                  !isArchiveProject()
              "
            >
              <button
                type="button"
                title="Этап 4. Обеспечение по возврату займа"
                class="stage-menu-item__butt"
                v-bind:class="{ active: step === 'banking-security' }"
                v-on:click="SetStep('banking-security')"
              >
                <span>Этап 4. Обеспечение по возврату займа</span>
                <a @click="startThirdScenariy" class="screenplay-start"></a>
              </button>
            </div>
            <div
              class="stage-menu-item"
              v-if="isArchiveProject() && project.UF_VERSION"
            >
              <button
                type="button"
                title="Этап 5 Обеспечение по возврату займа"
                v-bind:class="{ active: step === 'banking-security' }"
                v-on:click="SetStep('banking-security')"
                class="stage-menu-item__butt"
              >
                <span>Этап 5. Обеспечение по возврату займа</span>
                <a href="#" class="screenplay-start"></a>
              </button>
            </div>
            <div
              class="stage-menu-item"
              v-if="isArchiveProject() && !project.UF_VERSION"
            >
              <button
                type="button"
                title="Этап 5. Отправка резюме проекта"
                :class="{ active: step === 'resume' }"
                @click="SetStep('resume')"
              >
                Этап 5. Отправка резюме проекта
              </button>
            </div>

            <div
              class="stage-menu-item"
              v-if="getProgramCode() === 'konversia'"
            >
              <button
                type="button"
                title="Этап 5. Письмо-заверение"
                :class="{ active: step === 'letter' }"
                @click="SetStep('letter')"
              >
                Этап 5. Письмо-заверение
              </button>
            </div>
            <div class="stage-menu-item" v-show="false">
              <button
                type="button"
                title="Этап 6. Согласие на обработку персональных данных"
              >
                Этап 6. Согласие на обработку персональных данных
              </button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <form v-on:submit.prevent="onSubmit">
          <component
            v-if="rerender"
            @set="SetStep"
            :errorFields="saveErrorFields"
            :project="project"
            :is="curStep"
            ref="cStep"
            :isAccept="isAcceptProject"
          />
        </form>
      </div>

      <div
        class="modal fade in"
        v-bind:class="{ show: showWorkingModal }"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Внимание!</h4>
            </div>
            <div class="modal-body">
              Для участия в программе Заявителю необходимо быть участником
              региональной программы повышения производительности труда и
              получить сертификат АНО "Федеральный центр компетенций в сфере
              производительности труда" о наличии у компании ключевых элементов
              производительности системы и достаточном уровне использования
              внутренних ресурсов повышения производительности или получить
              протокол по созданию производственного потока-образца по итогам
              работы с ФЦК или РЦК.
              <div v-show="showConfirmWorkingModal">
                <br />
                <label>
                  <input
                    type="checkbox"
                    value="1"
                    v-model="disableWorkingModal"
                  />
                  Больше не выводить это сообщение
                </label>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
                @click="closeWorkingModal"
              >
                ОК
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
      </div>
      <!-- /.modal -->
      <div
        class="modal fade in"
        v-bind:class="{ show: showEpidemModal }"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Уважаемые заявители!</h4>
            </div>
            <div class="modal-body">
              <p>
                На текущий момент в стране решена задача по увеличению объема
                производства следующих видов продукции:
              </p>
              <ul style="list-style: disc">
                <li>Дезинфицирующие средства, кожные антисептики</li>
                <li>
                  Маски (за исключением создания производств полного цикла)
                </li>
              </ul>
              <p>
                Если вы собираетесь получить средства Фонда по программе
                «Противодействие эпидемическим заболеваниям» на производство
                вышеуказанной продукции, то с высокой вероятностью Ваш проект
                будет отклонен. Вы можете подать заявку на получение льготного
                займа по другим программам Фонда.
              </p>
              <p>
                Если Ваша организация занимается производством иной продукции,
                направленной на борьбу с COVID-19, например, производством
                аппаратов ИВЛ или противовирусных лекарственных препаратов, то
                такие проекты продолжают рассматриваться Фондом в рамках
                программы «Противодействие эпидемическим заболеваниям».
              </p>
              <div v-show="showConfirmEpidemModal">
                <br />
                <label>
                  <input
                    type="checkbox"
                    value="1"
                    v-model="disableEpidemModal"
                  />
                  Больше не выводить это сообщение
                </label>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
                @click="closeEpidemModal"
              >
                ОК
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
      </div>
      <!-- /.modal -->
      <SendProjectDialog v-if="showSendProjectDialog"></SendProjectDialog>
      <ChangeStatusDialog v-if="showChangeStatusDialog"></ChangeStatusDialog>
      <ChangeManagerDialog v-if="showChangeManagerDialog"></ChangeManagerDialog>
    </div>
    <div class="wraper" v-else-if="isLoading">
      <h3>Загрузка проекта...</h3>
    </div>
    <div v-else-if="isProjectLoadingError">
      <h3>Проект не найден!</h3>
    </div>
    <div class="footer footer-fix">
      <div class="container-fluid mycontainer-fluid">
        <div
          class="footer-sabmit"
          v-if="step !== '1' && step !== 'about'"
          v-show="!isLoading && !isProjectLoadingError"
        >
          <router-link
            v-if="isEditProject"
            v-show="
              !projectDisabled &&
                project.UF_IS_BLOCK !== 1 &&
                project.UF_IS_VIEW_EDIT_CONTROLLER != 1
            "
            tag="button"
            :to="{
              name: 'Projects'
            }"
            class="but-style but-ext screenplay-container"
            :class="[project.BUTTON_CANCEL ? 'active' : '']"
            id="screenplay-etap-1-3"
            value="Отмена"
            ref="BUTTON_CANCEL"
          >
            Отмена
            <FirstScenariosStep
              :project="project"
              step-name="BUTTON_CANCEL"
              custom-class="stl-lt"
            />
          </router-link>
          <button
            v-if="isEditProject"
            v-show="
              !projectDisabled &&
                project.UF_IS_BLOCK !== 1 &&
                project.UF_IS_VIEW_EDIT_CONTROLLER != 1
            "
            class="but-style but-save screenplay-container"
            :class="[project.BUTTON_SAVE ? 'active' : '']"
            @click="saveProject"
            ref="BUTTON_SAVE"
          >
            Сохранить
            <FirstScenariosStep
              :project="project"
              step-name="BUTTON_SAVE"
              custom-class="stl-lt"
            />
            <!--    Старая подсказка        -->
            <!--            <div class="info-holder-icon info-holder-icon_butt"></div>-->
            <!--            <div class="info-holder-content info-holder-content_butt">-->
            <!--              <div class="info-holder-content__text">-->
            <!--                Сохранить внесенные изменения. Вы сможете вернуться к заполнению-->
            <!--                позже-->
            <!--              </div>-->
            <!--            </div>-->
          </button>
          <!-- <button
            v-if="isEditProject"
            v-show="project.UF_IS_ACCEPT_PROJECT === 1 && isAcceptProject === 1"
            class="but-style but-save"
            style="width: 250px"
            @click="changeAcceptProject(0)"
          >
            Отправить резюме на доработку
          </button>
          <button
            v-if="isEditProject"
            v-show="project.UF_IS_ACCEPT_PROJECT !== 1 && isAcceptProject === 1"
            class="but-style but-save"
            style="width: 200px"
            @click="changeAcceptProject(1)"
          >
            Акцептовать резюме
          </button>-->
          <button
            v-if="
              isEditProject &&
                project.META.HEAD_BUTTON.IS_SHOW_BUTTON_SEND_IN_PROJECT == 1
            "
            v-show="
              !projectDisabled &&
                (this.projectStatusCode === 'draft' ||
                  this.projectStatusCode === 'express_grades_revision')
            "
            class="but-style but-push screenplay-container"
            :class="[project.BUTTON_SEND ? 'active' : '']"
            @click="prepareToSendProject"
            ref="BUTTON_SEND"
          >
            Отправить
            <FirstScenariosStep
              :project="project"
              step-name="BUTTON_SEND"
              custom-class="stl-lt"
            />
          </button>
          <button
            v-show="isChangeStatus"
            style="width: auto;"
            class="but-style but-push"
            v-on:click="showChangeStatusDialog = true"
          >
            Изменить статус
          </button>
          <button
            v-show="isChangeManager"
            style="width: auto;"
            class="but-style but-push"
            v-on:click="showChangeManagerDialog = true"
          >
            Изменить менеджера
          </button>
        </div>
        <div class="myfooter">
          <div class="myfooter-frp"></div>
        </div>
      </div>
    </div>
    <project-menu></project-menu>

    <div
      class="modal fade in show"
      v-if="showHelpEtap"
      tabindex="-1"
      role="dialog"
      style="margin: 10px;"
    >
      <div
        class="modal-content"
        :style="
          helpVideo.type === 'file'
            ? 'width:900px; margin:0 auto; margin-top:105px;'
            : ''
        "
      >
        <div class="modal-header">
          <button
            type="button"
            class="close"
            @click="handleModalShow"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Видеоинструкция
          </h4>
        </div>
        <div class="modal-body" style="min-height: 500px;">
          <iframe
            v-if="helpVideo && helpVideo.type === 'youtube'"
            width="100%"
            height="100%"
            :src="helpVideo.link"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            style="min-height: 500px"
          />

          <video
            v-if="helpVideo && helpVideo.type === 'file'"
            width="100%"
            height="500px"
            controls
            controlsList="nodownload"
            style="min-height: 500px"
            @contextmenu.prevent
          >
            <source :src="helpVideo.link" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default"
            @click="handleModalShow"
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import {
  FETCH_PROJECT,
  SAVE_PROJECT,
  FETCH_DIRECTORY,
  SEND_PROJECT,
  RESEND_PROJECT
} from "@/store/actions.type";
import { ProjectsService } from "@/common/api.service";
import SendProjectDialog from "@/components/project/form/SendProjectDialog";
import ChangeManagerDialog from "@/components/project/form/ChangeManagerDialog";
import ChangeStatusDialog from "@/components/project/form/ChangeStatusDialog";
import ProjectHeader from "@/components/project/partial/ProjectHeader";
import ProjectMenu from "@/components/project/partial/ProjectMenu";
import FirstScenariosStep from "@/components/project/form/subpartial/FirstScenariosStep.vue";
import HelpFiledStep2 from "@/components/project/form/subpartial/HelpFiledStep2.vue";

Vue.filter("toCurrency", function(value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("ru-RU", {
    style: "decimal",
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

export default {
  title: "Резюме проекта",
  name: "ProjectEdit",
  data() {
    return {
      isFirstLoaded: false,
      showSendProjectDialog: false,
      showChangeStatusDialog: false,
      showChangeManagerDialog: false,
      showWorkingModal: false,
      disableWorkingModal: false,
      showConfirmWorkingModal: true,
      showEpidemModal: false,
      disableEpidemModal: false,
      showConfirmEpidemModal: true,
      programCode: "",
      editId: "",
      loaded: false,
      showSaveError: false,
      saveErrors: [],
      tosterErrors: [],
      saveErrorFields: [],
      rerender: false,
      modalIsOpened: false,
      projectErrors: {},
      budgetErrors: {},
      mainCoverErrors: {},
      contactErrors: {},
      subContractErrors: {},
      planBuyersProductsErrors: {},
      providingMobilizationNeeds: {},
      digitalSolutionsErrors: {},
      bankGuarantErrors: {},
      budgetLizingErrors: {},
      otherSourceFinanceErrors: {},
      systemEquipmentErrors: {},
      systemIntegratorErrors: {},
      legalEntitiesErrors: {},
      zalogErrors: {},
      indicatorsErrors: {},
      step: "about",
      isChangeStatus: 0,
      isChangeManager: false,
      isEditProject: false,
      isAcceptProject: 0,
      helpEtapFlag: false,
      videosByEtapStep: {
        description: "https://youtube.com/embed/7sSAxhtVVK4",
        budget: "https://youtube.com/embed/nQqg39K0VEg",
        "banking-security": "https://youtube.com/embed/bW9T2prWpWs"
      },
      idsByEtapStep: {
        description: "1",
        budget: "3",
        "banking-security": "4"
      }
    };
  },
  components: {
    FirstScenariosStep,
    ProjectHeader,
    SendProjectDialog,
    ChangeStatusDialog,
    ProjectMenu,
    ChangeManagerDialog,
    HelpFiledStep2
  },

  computed: {
    projectStatus: function() {
      if (this.project.UF_STATUS_ID > 0) {
        let t = this.directory.status.filter(
          c => c.ID === this.project.UF_STATUS_ID
        );
        if (t.length > 0) {
          return t[0].NAME;
        }
      }
    },
    helpVideo() {
      return null;
    },
    projectStatusCode: function() {
      if (this.project.UF_STATUS_ID > 0) {
        let t = this.directory.status.filter(
          c => c.ID === this.project.UF_STATUS_ID
        );
        if (t.length > 0) {
          return t[0].CODE;
        }
      }
    },
    projectDisabled: function() {
      //67080 открыли доступ супервизору
      if (this.project.UF_IS_VIEW_EDIT_CONTROLLER == 1) {
        return false;
      }

      if (
        this.isArchiveProject() ||
        this.project.UF_IS_BLOCK == 1 ||
        this.isAcceptPlan
      ) {
        return true;
      }
      if (
        this.getProgramCode() === "lizing" &&
        this.currentUser.ACTIVE_ROLE_CODE === "users"
      ) {
        return true;
      }

      let t = this.directory.status.filter(
        c => c.ID === this.project.UF_STATUS_ID
      );
      if (t.length) {
        let mc = t[0].IS_MAKE_CHANGE;
        if (mc) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    curStep: function() {
      let code = this.getProgramCode();
      if (this.isArchiveProject() && this.step > 1) {
        code = "archive";
      }
      if (
        typeof Vue.options.components[`step_${this.step}_${code}`] !==
        "undefined"
      ) {
        return Vue.options.components[`step_${this.step}_${code}`];
      } else {
        if (
          this.project.IS_SHOW_TYPE_LOAN === 1 &&
          this.step == "banking_security"
        ) {
          return Vue.options.components[`step_${this.step}_scalable`];
        } else {
          return Vue.options.components[`step_${this.step}`];
        }
      }
    },
    showHelpEtap() {
      const checkHelpObject =
        !!this.project &&
        !!this.project.UF_SETTING &&
        !!this.project.UF_SETTING.IS_VIEW_HELP_ETAP;
      const firstCondition =
        checkHelpObject &&
        this.project.UF_SETTING.IS_VIEW_HELP_ETAP.IS_VIEW_ETAP_1 === 1 &&
        this.step === "description";
      const secondCondition =
        checkHelpObject &&
        this.project.UF_SETTING.IS_VIEW_HELP_ETAP.IS_VIEW_ETAP_3 === 1 &&
        this.step === "budget";
      const thirdCondition =
        checkHelpObject &&
        this.project.UF_SETTING.IS_VIEW_HELP_ETAP.IS_VIEW_ETAP_4 === 1 &&
        this.step === "banking-security";
      return (
        (firstCondition || secondCondition || thirdCondition) &&
        this.helpEtapFlag
      );
    },

    ...mapGetters([
      "project",
      "isLoading",
      "directory",
      "saveProjectErrors",
      "saveProjectSaved",
      "projectStatusHistory",
      "isProjectLoadingError",
      "currentUser",
      "showTotalMessageSaved",
      "versionSave",
      "textSaveTotalVersion2",
      "textSaveTotalOkVersion2"
    ])
  },

  async mounted() {
    try {
      await this.getIsAcceptProject();
    } catch (error) {
      console.error("Error in mounted hook:", error);
    }
  },

  async created() {
    await this.$store
      .dispatch(FETCH_DIRECTORY, ["status"])
      .then(() => {}, this);
    await this.$store
      .dispatch(FETCH_DIRECTORY, ["status_all"])
      .then(() => {}, this);

    this.$store.dispatch(FETCH_DIRECTORY, ["program_fin_support"]).then(() => {
      if (this.$route.params.step) {
        this.step = this.$route.params.step;
      }
      this.fetchProject(this.step);
    }, this);
  },

  methods: {
    // метод отправки запроса при закрытии модального окна с видо подсказкой
    async handleModalShow() {
      this.helpEtapFlag = false;
      ProjectsService.setReadEtapPause(this.$route.params.id, {
        IS_VIEW_ETAP_NUMBER: this.idsByEtapStep[this.step]
      }).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        } else {
          this.fetchProject(this.step);
        }
      }, this);
    },
    startFirstScenariy() {
      if (this.step === "planned-indicators") {
        const el = document.getElementsByClassName("area-shadow")[0];
        el.classList.add("active");
        const footer = document.getElementsByClassName("footer")[0];
        footer.classList.add("active");
        Vue.set(this.project, `${this.project.ARR1[0]}`, true);
      }
    },
    startSecondScenariy() {
      if (this.step === "budget") {
        const el = document.getElementsByClassName("area-shadow")[0];
        el.classList.add("active");
        const footer = document.getElementsByClassName("footer")[0];
        footer.classList.add("active");
        Vue.set(this.project, `${this.project.ARR2[0]}`, true);
      }
    },
    startThirdScenariy() {
      if (this.step === "banking-security") {
        const el = document.getElementsByClassName("area-shadow")[0];
        el.classList.add("active");
        const footer = document.getElementsByClassName("footer")[0];
        footer.classList.add("active");
        Vue.set(this.project, `${this.project.ARR3[0]}`, true);
      } else if (this.getProgramCode() === "lizing" && this.step === "budget") {
        const el = document.getElementsByClassName("area-shadow")[0];
        el.classList.add("active");
        const footer = document.getElementsByClassName("footer")[0];
        footer.classList.add("active");
        Vue.set(this.project, `${this.project.ARR3[0]}`, true);
      }
    },
    changeAcceptProject(params) {
      ProjectsService.changeAcceptProject(this.project.ID, params);
      this.reSendProject();
    },
    closeWorkingModal() {
      if (this.disableWorkingModal) {
        ProjectsService.setReadAlertProject(this.project.ID);
      }
      this.showWorkingModal = false;
      this.showConfirmWorkingModal = false;
    },
    closeEpidemModal() {
      if (this.disableEpidemModal) {
        ProjectsService.setReadAlertProject(this.project.ID);
      }
      this.showEpidemModal = false;
      this.showConfirmEpidemModal = false;
    },
    SetStep(step, target) {
      if (this.$route.params.step !== step) {
        this.$router.push({
          name: "ProjectEditStep",
          params: { id: this.project.ID, step: step },
          hash: target
        });
      }
      this.rerender = false;
      this.step = step;
      this.helpEtapFlag = true;
      this.rerender = true;
      setTimeout(
        () => {
          if (this.$router.currentRoute.hash) {
            let element = this.$refs["cStep"].$refs[
              this.$router.currentRoute.hash.substring(1)
            ];
            if (element !== undefined) {
              window.scrollTo(0, element.offsetTop);
            }
          }
        },
        100,
        this
      );
    },
    addBudgetError(err) {
      if (typeof err.DOP_INFO === "undefined") return;
      if (typeof this.budgetErrors[err.DOP_INFO.ROW_ID] === "undefined") {
        this.budgetErrors[err.DOP_INFO.ROW_ID] = {};
      }
      err.DOP_INFO.COL.forEach(function(col) {
        this.budgetErrors[err.DOP_INFO.ROW_ID][col] = err.TEXT;
      }, this);
    },
    addMainCoverError(err) {
      if (typeof err.DOP_INFO === "undefined") return;
      if (typeof this.mainCoverErrors[err.DOP_INFO.ROW_ID] === "undefined") {
        this.mainCoverErrors[err.DOP_INFO.ROW_ID] = {};
      }
      err.DOP_INFO.COL.forEach(function(col) {
        this.mainCoverErrors[err.DOP_INFO.ROW_ID][col] = err.TEXT;
      }, this);
    },
    addContactError(err) {
      if (typeof err.DOP_INFO === "undefined") return;
      if (typeof this.contactErrors[err.DOP_INFO.ROW_NUM] === "undefined") {
        this.contactErrors[err.DOP_INFO.ROW_NUM] = {};
      }
      this.contactErrors[err.DOP_INFO.ROW_NUM][err.FIELDS] = err.TEXT;
    },
    addSubContractError(err) {
      if (typeof err.DOP_INFO === "undefined") return;
      if (typeof this.subContractErrors[err.DOP_INFO.ROW_NUM] === "undefined") {
        this.subContractErrors[err.DOP_INFO.ROW_NUM] = {};
      }
      err.DOP_INFO.COL.forEach(function(col) {
        this.subContractErrors[err.DOP_INFO.ROW_NUM][col] = err.TEXT;
      }, this);
    },
    addProvidingMobilizationError(err) {
      if (typeof err.DOP_INFO === "undefined") return;
      if (
        typeof this.providingMobilizationNeeds[err.DOP_INFO.ROW_NUM] ===
        "undefined"
      ) {
        this.providingMobilizationNeeds[err.DOP_INFO.ROW_NUM] = {};
      }
      err.DOP_INFO.COL.forEach(function(col) {
        this.providingMobilizationNeeds[err.DOP_INFO.ROW_NUM][col] = err.TEXT;
      }, this);
    },
    addPlanBuyersProductsError(err) {
      if (typeof err.DOP_INFO === "undefined") return;
      if (
        typeof this.planBuyersProductsErrors[err.DOP_INFO.ROW_NUM] ===
        "undefined"
      ) {
        this.planBuyersProductsErrors[err.DOP_INFO.ROW_NUM] = {};
      }
      err.DOP_INFO.COL.forEach(function(col) {
        this.planBuyersProductsErrors[err.DOP_INFO.ROW_NUM][col] = err.TEXT;
      }, this);
    },
    addDigitalSolutionsError(err) {
      if (typeof err.DOP_INFO === "undefined") return;
      if (
        typeof this.digitalSolutionsErrors[err.DOP_INFO.ROW_NUM] === "undefined"
      ) {
        this.digitalSolutionsErrors[err.DOP_INFO.ROW_NUM] = {};
      }
      err.DOP_INFO.COL.forEach(function(col) {
        this.digitalSolutionsErrors[err.DOP_INFO.ROW_NUM][col] = err.TEXT;
      }, this);
    },
    addBankGuarantError(err) {
      if (typeof err.DOP_INFO === "undefined") return;
      if (typeof this.bankGuarantErrors[err.DOP_INFO.ROW_NUM] === "undefined") {
        this.bankGuarantErrors[err.DOP_INFO.ROW_NUM] = {};
      }
      err.DOP_INFO.COL.forEach(function(col) {
        this.bankGuarantErrors[err.DOP_INFO.ROW_NUM][col] = err.TEXT;
      }, this);
    },
    addBudgetLizingError(err) {
      if (typeof err.DOP_INFO === "undefined") return;
      if (typeof this.budgetLizingErrors[err.DOP_INFO.ROW_ID] === "undefined") {
        this.budgetLizingErrors[err.DOP_INFO.ROW_ID] = {};
      }
      err.DOP_INFO.COL.forEach(function(col) {
        this.budgetLizingErrors[err.DOP_INFO.ROW_ID][col] = err.TEXT;
      }, this);
    },
    addOtherSourceFinanceError(err) {
      if (typeof err.DOP_INFO === "undefined") return;
      if (
        typeof this.otherSourceFinanceErrors[err.DOP_INFO.ROW_NUM] ===
        "undefined"
      ) {
        this.otherSourceFinanceErrors[err.DOP_INFO.ROW_NUM] = {};
      }
      err.DOP_INFO.COL.forEach(function(col) {
        this.otherSourceFinanceErrors[err.DOP_INFO.ROW_NUM][col] = err.TEXT;
      }, this);
    },
    addSystemIntegratorError(err) {
      if (typeof err.DOP_INFO === "undefined") return;
      if (
        typeof this.systemIntegratorErrors[err.DOP_INFO.ROW_NUM] === "undefined"
      ) {
        this.systemIntegratorErrors[err.DOP_INFO.ROW_NUM] = {};
      }
      err.DOP_INFO.COL.forEach(function(col) {
        this.systemIntegratorErrors[err.DOP_INFO.ROW_NUM][col] = err.TEXT;
      }, this);
    },
    addLegalEntitiesError(err) {
      if (typeof err.DOP_INFO === "undefined") return;
      if (
        typeof this.legalEntitiesErrors[err.DOP_INFO.ROW_NUM] === "undefined"
      ) {
        this.legalEntitiesErrors[err.DOP_INFO.ROW_NUM] = {};
      }
      err.DOP_INFO.COL.forEach(function(col) {
        this.legalEntitiesErrors[err.DOP_INFO.ROW_NUM][col] = err.TEXT;
      }, this);
    },
    addZalogError(err) {
      if (typeof err.DOP_INFO === "undefined") return;
      if (typeof this.zalogErrors[err.DOP_INFO.ROW_NUM] === "undefined") {
        this.zalogErrors[err.DOP_INFO.ROW_NUM] = {};
      }
      err.DOP_INFO.COL.forEach(function(col) {
        this.zalogErrors[err.DOP_INFO.ROW_NUM][col] = err.TEXT;
      }, this);
    },
    addSystemEquipmentError(err) {
      if (typeof err.DOP_INFO === "undefined") return;
      if (
        typeof this.systemEquipmentErrors[err.DOP_INFO.ROW_NUM] === "undefined"
      ) {
        this.systemEquipmentErrors[err.DOP_INFO.ROW_NUM] = {};
      }
      err.DOP_INFO.COL.forEach(function(col) {
        this.systemEquipmentErrors[err.DOP_INFO.ROW_NUM][col] = err.TEXT;
      }, this);
    },
    addIndicatorError(err) {
      if (typeof err.DOP_INFO === "undefined") return;
      if (typeof this.indicatorsErrors[err.DOP_INFO.ROW_ID] === "undefined") {
        this.indicatorsErrors[err.DOP_INFO.ROW_ID] = {};
      }
      if (
        typeof this.indicatorsErrors[err.DOP_INFO.ROW_ID][
          err.DOP_INFO.ROW_NUM
        ] === "undefined"
      ) {
        this.indicatorsErrors[err.DOP_INFO.ROW_ID][err.DOP_INFO.ROW_NUM] = {};
      }
      err.DOP_INFO.COL.forEach(function(col) {
        this.indicatorsErrors[err.DOP_INFO.ROW_ID][err.DOP_INFO.ROW_NUM][col] =
          err.TEXT;
      }, this);
    },
    async saveProject() {
      this.tosterErrors.forEach(function(err) {
        err.goAway(0);
      });
      this.tosterErrors = [];
      this.saveErrorFields = {};
      this.projectErrors = {};
      this.budgetErrors = {};
      this.mainCoverErrors = {};
      this.contactErrors = {};
      this.subContractErrors = {};
      this.planBuyersProductsErrors = {};
      this.digitalSolutionsErrors = {};
      this.bankGuarantErrors = {};
      this.budgetLizingErrors = {};
      this.otherSourceFinanceErrors = {};
      this.systemEquipmentErrors = {};
      this.systemIntegratorErrors = {};
      this.legalEntitiesErrors = {};
      this.zalogErrors = {};
      this.indicatorsErrors = {};
      this.providingMobilizationNeeds = {};
      const s = await this.$store
        .dispatch(SAVE_PROJECT, { ...this.project, step: this.step })
        .then(() => {
          if (this.saveProjectSaved) {
            this.fetchProject(this.step);
          }
          if (this.saveProjectErrors.length > 0) {
            this.saveProjectErrors.forEach(function(err) {
              if (err.MODEL === "BUDGET") {
                this.addBudgetError(err);
              }
              if (err.MODEL === "MAIN_COVER") {
                this.addMainCoverError(err);
              }
              if (err.MODEL === "CONTACTS") {
                this.addContactError(err);
              }
              if (err.MODEL === "PROVIDING_MOBILIZATION_NEEDS") {
                this.addProvidingMobilizationError(err);
              }
              if (err.MODEL === "SUBCONTRACTORS") {
                this.addSubContractError(err);
              }
              if (err.MODEL === "PLAN_BUYERS_PRODUCTS") {
                this.addPlanBuyersProductsError(err);
              }
              if (err.MODEL === "DIGITAL_SOLUTION") {
                this.addDigitalSolutionsError(err);
              }
              if (err.MODEL === "BANK_GUARANTEE") {
                this.addBankGuarantError(err);
              }
              if (err.MODEL === "BUDGET_LIZING") {
                this.addBudgetLizingError(err);
              }
              if (err.MODEL === "OTHER_SOURCE_FINANCE") {
                this.addOtherSourceFinanceError(err);
              }
              if (err.MODEL === "INDICATORS") {
                this.addIndicatorError(err);
              }
              if (err.MODEL === "PURCHASED_EQUIPMENT") {
                this.addSystemEquipmentError(err);
              }
              if (err.MODEL === "SYSTEM_INTEGRATOR") {
                this.addSystemIntegratorError(err);
              }
              if (err.MODEL === "LEGAL_ENTITIES") {
                this.addLegalEntitiesError(err);
              }
              if (err.MODEL === "ZALOG") {
                this.addZalogError(err);
              }
              if (typeof err.TYPE === "undefined") {
                err.TYPE = "LOGIC";
              }
              if (typeof this.saveErrorFields[err.MODEL] === "undefined") {
                this.saveErrorFields[err.MODEL] = {};
              }
              if (
                typeof this.saveErrorFields[err.MODEL][err.TYPE] === "undefined"
              ) {
                this.saveErrorFields[err.MODEL][err.TYPE] = {};
              }
              this.saveErrorFields[err.MODEL][err.TYPE][err.FIELDS] = err.TEXT;
              this.tosterErrors[this.tosterErrors.length] = this.$toasted.show(
                err.TEXT,
                {
                  theme: "bubble",
                  position: "bottom-right",
                  duration: null,
                  action: [
                    {
                      text: "Закрыть",
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      }
                    },
                    {
                      text: "Закрыть все",
                      onClick: () => {
                        this.tosterErrors.forEach(function(err) {
                          err.goAway(0);
                        });
                      }
                    }
                  ]
                }
              );
            }, this);

            if (this.showTotalMessageSaved) {
              console.log(this.versionSave);
              if (this.versionSave == 2) {
                this.tosterErrors[
                  this.tosterErrors.length
                ] = this.$toasted.show(this.textSaveTotalVersion2, {
                  theme: "red",
                  position: "bottom-right",
                  duration: null,
                  action: [
                    {
                      text: "Закрыть",
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      }
                    },
                    {
                      text: "Закрыть все",
                      onClick: () => {
                        this.tosterErrors.forEach(function(err) {
                          err.goAway(0);
                        });
                      }
                    }
                  ]
                });
              } else {
                this.tosterErrors[
                  this.tosterErrors.length
                ] = this.$toasted.show(
                  this.getStatus(this.project.UF_STATUS_ID).CODE === "draft"
                    ? "Проект сохранен, но для отправки проекта для проверки в ФРП, необходимо устранить указанные ошибки"
                    : this.saveProjectSaved && this.saveProjectErrors
                    ? "Изменения сохранены. Пожалуйста, устраните замечания во избежании дальнейших ошибок"
                    : "Изменения не сохранены. Пожалуйста, устраните замечания для сохранения резюме",
                  {
                    theme: "red",
                    position: "bottom-right",
                    duration: null,
                    action: [
                      {
                        text: "Закрыть",
                        onClick: (e, toastObject) => {
                          toastObject.goAway(0);
                        }
                      },
                      {
                        text: "Закрыть все",
                        onClick: () => {
                          this.tosterErrors.forEach(function(err) {
                            err.goAway(0);
                          });
                        }
                      }
                    ]
                  }
                );
              }
            }

            this.rerender = false;
            this.rerender = true;
            return false;
          } else if (this.saveProjectSaved) {
            if (this.versionSave == 2) {
              this.$toasted.show(this.textSaveTotalOkVersion2, {
                theme: "green",
                position: "bottom-right",
                duration: 3500
              });
            } else {
              this.$toasted.show("Проект успешно сохранен", {
                theme: "green",
                position: "bottom-right",
                duration: 3500
              });
            }
          }
          return true;
        });
      return s;
    },
    async prepareToSendProject() {
      this.tosterErrors.forEach(function(err) {
        err.goAway(0);
      });
      const s = await this.saveProject();
      if (s) {
        if (this.tosterErrors.length === 0) {
          if (this.projectStatusCode === "draft") {
            this.showSendProjectDialog = true;
          } else if (this.projectStatusCode === "express_grades_revision") {
            this.reSendProject();
          }
        }
      }
    },
    sendProject() {
      this.$store.dispatch(SEND_PROJECT, this.project).then(() => {
        this.showSendProjectDialog = false;
        this.fetchProject(this.step);
      }, this);
    },
    reSendProject() {
      this.$store.dispatch(RESEND_PROJECT, this.project).then(() => {
        this.showSendProjectDialog = false;
        this.fetchProject(this.step);
      }, this);
    },
    checkErrorField(project, type, field) {
      if (typeof this.saveErrorFields[project] === "undefined") {
        return false;
      }
      if (typeof this.saveErrorFields[project][type] === "undefined") {
        return false;
      }
      if (typeof this.saveErrorFields[project][type][field] === "undefined") {
        return false;
      }
      return true;
    },
    checkErrorText(project, type, field) {
      if (typeof this.saveErrorFields[project] === "undefined") {
        return "";
      }
      if (typeof this.saveErrorFields[project][type] === "undefined") {
        return "";
      }
      if (typeof this.saveErrorFields[project][type][field] === "undefined") {
        return "";
      }
      return this.saveErrorFields[project][type][field];
    },
    removeError(project, type, field) {
      if (typeof this.saveErrorFields[project] === "undefined") {
        return "";
      }
      if (typeof this.saveErrorFields[project][type] === "undefined") {
        return "";
      }
      if (typeof this.saveErrorFields[project][type][field] === "undefined") {
        return "";
      }

      Vue.delete(this.saveErrorFields[project][type], field);
    },
    onSubmit() {
      if (this.editId !== "") {
        // db.collection("products").doc(this.editId).set(this.fm);
      } else {
        // db.collection("products").add(this.fm);
      }
      this.$router.push({ name: "Projects" });
    },
    async fetchProject(step) {
      await this.$store.dispatch(FETCH_PROJECT, this.$route.params.id);
      if (!step) {
        step = this.step;
      }
      this.isFirstLoaded = true;
      this.prepareData(step);
    },
    prepareData(step) {
      if (typeof this.project.INDICATORS.items === "undefined") {
        this.project.INDICATORS.items = new Object();
      }
      if (typeof this.project.FINANCIAL_INDICATORS.items === "undefined") {
        this.project.FINANCIAL_INDICATORS.items = new Object();
      }
      if (this.currentUser.TYPE_USER === "manager") {
        ProjectsService.getRulesChangeStatusUser(
          this.project.UF_STATUS_ID
        ).then(({ data }) => {
          this.isChangeStatus =
            data.IS_CHANGE_STATUS && data.RAZDEL_CHANGE === "PROJECT";

          if (
            this.project.UF_IS_PROJECT_REGIONAL_PROGRAMM === 0 &&
            this.currentUser.ACTIVE_ROLE_CODE === "region_fond"
          ) {
            this.isChangeStatus = false;
          }

          this.isEditProject = data.IS_EDIT_PROJECT;
          if (this.isChangeStatus) {
            this.isChangeManager = data.IS_CHANGE_MANAGER;
          }
          this.isAcceptProject = data.IS_ACCEPT_PROJECT;
        }, this);
      }

      if (this.currentUser.TYPE_USER === "declarer") {
        ProjectsService.getRulesChangeStatusUser(
          this.project.UF_STATUS_ID
        ).then(({ data }) => {
          this.isEditProject = data.IS_EDIT_PROJECT;
        }, this);
      }

      if (this.project.ORG_INFO === false) {
        this.project.ORG_INFO = {};
      }

      if (
        this.currentUser.TYPE_USER === "declarer" &&
        (this.getProgramCode() === "working" ||
          this.getProgramCode() === "working_rfrp")
      ) {
        ProjectsService.readAlertProject(this.project.ID).then(({ data }) => {
          if (data.result === 0) {
            this.showWorkingModal = true;
          } else {
            this.showConfirmWorkingModal = false;
          }
        });
      }
      if (
        this.currentUser.TYPE_USER === "declarer" &&
        this.getProgramCode() === "epidemiological_control"
      ) {
        ProjectsService.readAlertProject(this.project.ID).then(({ data }) => {
          if (data.result === 0) {
            this.showEpidemModal = true;
          } else {
            this.showConfirmEpidemModal = false;
          }
        });
      }
      this.SetStep(step);
    },
    updateAllSumPercent() {
      ProjectsService.calcSum(this.project.ID, {
        UF_SUPPORT_PROG_ID: this.project.UF_SUPPORT_PROG_ID,
        UF_SUM_REQUEST: this.project.UF_SUM_REQUEST,
        UF_MONTH_RETURN: this.project.UF_MONTH_RETURN,
        UF_OLD_KRVARTAL: this.project.UF_OLD_KRVARTAL,
        UF_IS_ALL_ZAIM_PR: this.project.UF_IS_ALL_ZAIM_PR,
        UF_STAVKA_PR_YEAR: this.project.UF_STAVKA_PR_YEAR,
        UF_LIZING_CONCLUSION_ID: this.project.UF_LIZING_CONCLUSION_ID
      }).then(({ data }) => {
        this.project.UF_ALL_SUMM_PROCENT = data.sum;
      });

      //при изменении суммы, если проект с новыми настройками - перестроить таблицу показателей
      if (
        this.project.UF_SETTING.IS_NEW_RULES_YEARS_COUNT_INDICATOR_23 == 1 &&
        this.project.INDICATORS.yearStart &&
        this.project.INDICATORS.yearStart > 0
      ) {
        ProjectsService.getNewIndicticatorByChangeMonthProject(
          this.project.ID,
          {
            INDICATORS: this.project.INDICATORS,
            UF_MONTH_RETURN: this.project.UF_MONTH_RETURN
          }
        ).then(({ data }) => {
          this.project.INDICATORS = data;
        });
      }
    },
    updateAllSumPercent2() {
      ProjectsService.calcSum(this.project.ID, {
        UF_SUPPORT_PROG_ID: this.project.UF_SUPPORT_PROG_ID,
        UF_SUM_REQUEST: this.project.UF_SUM_REQUEST,
        UF_MONTH_RETURN: this.project.UF_MONTH_RETURN,
        UF_OLD_KRVARTAL: this.project.UF_OLD_KRVARTAL,
        UF_IS_ALL_ZAIM_PR: this.project.UF_IS_ALL_ZAIM_PR2,
        UF_STAVKA_PR_YEAR: this.project.UF_STAVKA_PR_YEAR,
        UF_LIZING_CONCLUSION_ID: this.project.UF_LIZING_CONCLUSION_ID
      }).then(({ data }) => {
        this.project.UF_ALL_SUMM_PROCENT = data.sum;
      });
    },
    getStatusName: function(id) {
      let t = this.directory.status.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0].NAME;
      }
    },
    getStatus: function(id) {
      let t = this.directory.status.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0];
      }
    },
    isArchiveProject() {
      let t = this.directory.program_fin_support.filter(
        c => c.ID === this.project.UF_SUPPORT_PROG_ID
      );
      if (t.length > 0) {
        return t[0].UF_IS_ARHIVE;
      }
      return "";
    },
    getProgramCode() {
      let t = this.directory.program_fin_support.filter(
        c => c.ID === this.project.UF_SUPPORT_PROG_ID
      );
      if (t.length > 0) {
        return t[0].CODE;
      }
      return "";
    },
    getProgramIsBlock() {
      let t = this.directory.program_fin_support.filter(
        c => c.ID === this.project.UF_SUPPORT_PROG_ID
      );
      if (t.length > 0) {
        return t[0].UF_IS_BLOCK_PROGRAM;
      }
      return "";
    },
    async getIsAcceptProject() {
      try {
        if (!this.project || !this.project.UF_STATUS_ID) {
          console.warn("Project or status ID is not available");
          return;
        }

        const { data } = await ProjectsService.getRulesChangeStatusUser(
          this.project.UF_STATUS_ID
        );

        if (data) {
          console.log(data);
          this.isAcceptProject = data.IS_ACCEPT_PROJECT;
          console.log("this.project.UF_STATUS_ID", this.project.UF_STATUS_ID);
          console.log("data.IS_ACCEPT_PROJECT", data.IS_ACCEPT_PROJECT);
        }
      } catch (error) {
        console.error("Error getting project accept status:", error);
        this.isAcceptProject = false;
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.tosterErrors.forEach(function(err) {
      err.goAway(0);
    });
    next();
  }
};
</script>

<style scoped>
h3 {
  text-align: center;
  margin-top: 30px;
  margin-bottom: 20px;
}
</style>
